export default __webpack_public_path__ + "static/1142-0abb390d2478a4d5b7becd4b88e106a1.gif";